<template>
  <pict
    class="high-five-image__image"
    block-name="high-five-image"
    :modifiers="['rendering-pixelated']"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageL from "./images/highfive.png"
import imageL2 from "./images/highfive@2x.png"
import imageS from "./images/highfive_s.png"
import imageS2 from "./images/highfive_s@2x.png"

export default {
  name: "High5Image",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2
          }
        },
        sources: [
          {
            media: "s",
            src: imageS,
            srcset: {
              "2x": imageS2
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "A person with long dark hair and wearing blue glasses and a yellow shirt striped with blue taps on a yellow envelope on their mobile device. Another person with long dark hair and fringe, wearing a blue shirt with white dots receives a blue gift with a yellow bow on their  mobile device."
      },
      de: {
        alt: "Die Illustration zeigt zwei Personen: Die erste Person trägt eine gelb-blau gestreifte Bluse und hält ein Tablet, von dem aus eine Einladung in Form eines Papierflugzeugs zur zweiten Person in einer blauen Bluse fliegt. Diese hält ebenfalls ein Tablet. Die Einladung kommt in Form eines glau-gelben Geschenks auf ihrem Tablet an."
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.high-five-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
